import qs from 'qs'

const createURL = (state) => {
  const { configure, ...stateWithoutConfigure } = state
  // Remove "_development" or "_production" suffixes only for the "sortBy" parameter
  const sanitizedState = {
    ...stateWithoutConfigure,
    sortBy: stateWithoutConfigure.sortBy
      ? stateWithoutConfigure.sortBy.replace(/_(development|production)$/, '')
      : stateWithoutConfigure.sortBy
  }
  return `?${qs.stringify(sanitizedState, {})}`
}

export default createURL
